// Whether the matter page offers "Share with an outside expert" — the
// staff door to the passkey portal.
//
// Matthew, 10/30: hidden on every file until the portal is finished (the
// take-everything download, the return lane for the expert's opinion, and
// the outside security test) and switched on in production. Until then
// the button was a dead door: it listed folders to tick, but no outside
// firm is cleared on the live site and the portal itself is off there, so
// the sign-in link it handed over went nowhere. In its place the file
// offers the same "Share externally" link the folder right-click has.
//
// Flipping this brings back, together, the button, the "shared outside"
// badge beside it, and the per-visit summary request that feeds the badge.
export const OUTSIDE_EXPERT_SHARE_ENABLED = false;
